import { Component, Input, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { WebcamImage, WebcamInitError, WebcamModule } from 'ngx-webcam';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { RemedialImage } from '../../_models/RemedialImage';
import {CommonModule} from "@angular/common";

@Component({
  selector: 'remedial-images',
  templateUrl: './remedial-images.component.html',
  styleUrls: ['./remedial-images.component.css'],
  standalone: true,
  imports: [WebcamModule, CommonModule]
})
export class RemedialImagesComponent implements OnInit {
  @Input() images: RemedialImage[] = [];
  @Input() showCamera: boolean = false;

  public webcamImages: WebcamImage[] = [];
  public selectedImageSrc: string = '';
  public cameraError: boolean = false;

  public videoOptions: MediaTrackConstraints = {
    width: { ideal: 1920 },
    height: { ideal: 1080 }
  };

  private trigger: Subject<void> = new Subject<void>();

  constructor(private toasterService: ToastrService) {}

  ngOnInit(): void {}

  // Webcam snapshot trigger
  get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  triggerSnapshot(): void {
    this.trigger.next();
  }

  handleImage(webcamImage: WebcamImage): void {
    this.webcamImages.push(webcamImage);
  }

  handleInitError(error: WebcamInitError): void {
    this.showCamera = false;
    this.cameraError = true;

    if (error.mediaStreamError?.name === 'NotFoundError') {
      this.toasterService.error('Unable to detect camera');
    }

    if (error.mediaStreamError?.name === 'NotAllowedError') {
      this.toasterService.error('You must allow access to the camera');
    }
  }

  removeWebcamImage(image: WebcamImage): void {
    this.webcamImages = this.webcamImages.filter(x => x.imageAsBase64 !== image.imageAsBase64);
  }

  removeImage(image: RemedialImage): void {
    this.images = this.images.filter(x => x.url !== image.url);
  }

  showImage(imageSrc: string): void {
    Swal.fire({
      imageUrl: imageSrc,
      width: '75%',
      showConfirmButton: true
    });
  }

  // Programmatic Trace Request modal
  confirmTraceRequest(): void {
    Swal.fire({
      title: 'Trace Request',
      html: `<div class="card text-white bg-info text-center">
               <div class="p-1">
                 <p>As no contract number has been specified/located, a trace request will be created instead.</p>
               </div>
             </div>`,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      width: '500px'
    }).then(result => {
      if (result.isConfirmed) {
        console.log('Trace request confirmed!');
        // Trigger parent callback if needed
      }
    });
  }
}
